import { Wrapper } from '@american-autonomy/ag-ui';

import MultiSelectPanel from 'components/MultiSelectPanel';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { ENTITY_TYPE, TEST_ID } from './constants';
import type { FunctionComponent, Item, Props } from './types';

const RoleMultiSelectPanelField: FunctionComponent<Props> = ({
    className = '',
    onChange,
    testId = TEST_ID,
    value
}) => {
    const { SEARCH } = useTranslation();
    const { roleItems } = useData();

    const handleToggle = (role: Item) => {
        const isSelected = value.some(item => item.value === role.value);

        if (isSelected) {
            onChange(value.filter(item => item.value !== role.value));
        } else {
            onChange([...value, role]);
        }
    };

    return (
        <Wrapper className={className} testId={testId}>
            <MultiSelectPanel
                entityType={ENTITY_TYPE}
                items={roleItems}
                itemsSelected={value}
                label={SEARCH}
                onToggle={handleToggle}
            />
        </Wrapper>
    );
};

export default RoleMultiSelectPanelField;
